import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

import { message, notification } from 'antd';

const label = 'logoutOneDrive';

const handler = async (actions) => {
  const oneDriveLogouResult = await api.getOneDriveLogout();

  if (oneDriveLogouResult) {
    localStorage.setItem('onedrive_login_result', JSON.stringify({ isSuccess: false }));

    notification.success({
      message: 'Success',
      top: 55,
      duration: 10,
      getContainer: actions.rootContainer,
      description: 'Successfully logged out from OneDrive',
    });
  }
};

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);

  return {
    id: label,
    icon: { icon: icons.logout },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const resource = actions.getSelectedResources();

      let loggedItem = null;
      try {
        loggedItem = JSON.parse(localStorage.getItem('onedrive_login_result'));
      } catch (e) {
        return null;
      }

      const logged = loggedItem?.isSuccess;

      return resource.length === 1 && resource[0].id.toString().endsWith('_onedrive') && resource[0].isSystemFolder === true
        ? // && logged
          true
        : false;
    },
    availableInContexts: ['row'],
    handler: () => handler(actions),
  };
};
